<template>
  <div class="pw-header-parent-pc">
    <div class="pw-header-grid-pc">
      <div class="pw-header-menu-pc" id="pw-header-pc-home">
        <a href="https://pawaiipets.com"
          ><span class="pw-header-menu-text-pc">Home</span></a
        >
        <div class="pw-header-active-border-pc"></div>
      </div>
      <div class="pw-header-menu-pc" id="pw-header-pc-products">
        <a href="https://pawaiipets.com/product"
          ><span class="pw-header-menu-text-pc">Products</span></a
        >
        <div class="pw-header-active-border-pc"></div>
      </div>
      <div class="pw-header-icon-pc">
        <a href="https://pawaiipets.com"
          ><img src="../../assets/img/header/pw-icon-pc.png" alt="pw-icon"
        /></a>
      </div>
      <div class="pw-header-menu-pc" id="pw-header-pc-pet-finder">
        <a href="https://pawaiipets.com/pet-finder"
          ><span class="pw-header-menu-text-pc pw-header-active-border-pc-finder">Pet Finder</span></a
        >
        <div class="pw-header-active-border-pc pw-header-active-border-pc-finder"></div>
      </div>
      <div class="pw-header-menu-pc" id="pw-header-pc-about-us">
        <a href="https://pawaiipets.com/about-us"
          ><span class="pw-header-menu-text-pc">About Us</span></a
        >
        <div class="pw-header-active-border-pc"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VueHeader",
};
</script>

<style scoped="">
.pw-header-parent-pc {
  backdrop-filter: blur(20px);
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 999;
}
.pw-header-parent-pc-blogpage {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(20px) !important;
}
.pw-header-grid-pc {
  display: grid;
  grid-template-columns: repeat(5, 20%);
  justify-items: center;
  align-items: center;
  max-width: 1070px;
  margin: 0 auto;
  padding-top: 15px; 
}
.pw-header-menu-pc {
  font-family: "Poppins";
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  color: #1a1a1a;
  text-transform: capitalize;
  position: relative;
}
.pw-header-menu-text-pc {
  display: block;
  margin-top: 23px;
  margin-bottom: 15px;
  cursor: pointer;
  width: 100px;
  text-align: center;
  font-family: "Poppins";
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #1a1a1a;
  text-transform: capitalize;
}
.pw-header-icon-pc img {
  margin-bottom: 15px;
  height: 50px;
  display: block;
}
.pw-header-menu-pc a:hover .pw-header-menu-text-pc {
  color: #FF5349;
}
.pw-header-parent-pc-blogpage
  .pw-header-menu-pc
  a:hover
  .pw-header-menu-text-pc {
  color: #ff5349;
}
.pw-header-menu-pc a:hover + .pw-header-active-border-pc {
  display: block;
}
.pw-header-active-border-pc {
  position: absolute;
  bottom: 8px;
  left: 10px;
  height: 4px;
  width: 80px;
  background-color: #FF5349;
  border-radius: 10px;
  display: none;
}
.pw-header-active-border-pc-finder{
    color: #FF5349;
    display: block;
}
.pw-header-parent-pc-blogpage .pw-header-active-border-pc {
  background-color: #ff5349;
}
.pw-header-active-pc .pw-header-menu-text-pc {
  color: #1a1a1a;
}
.pw-header-parent-pc-blogpage .pw-header-active-pc .pw-header-menu-text-pc {
  color: #ff5349;
}
.pw-header-active-pc .pw-header-active-border-pc {
  display: block;
}
</style>
